<template>
  <div class="one-time-pass-register-modal-section">
    <div class="one-time-pass-register-modal-section__header">
      <modal-title-parts :title="$tc('common.flowLineToPaidPlan.discount.oneTime.title')" />
      <modal-message-parts :message="$tc('common.flowLineToPaidPlan.discount.oneTime.message')" />
    </div>

    <div class="one-time-pass-register-modal-section__body">
      <modal-coupon-plan-card-parts :plan="oneTimePassPlan" />
    </div>

    <div class="one-time-pass-register-modal-section__footer">
      <!-- プラン登録ボタン -->
      <atom-button :linkText="$tc('common.registration')" @onClick="handleRegistrationClicked" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, Ref } from '@vue/composition-api'
import ModalTitleParts from '@/components/common/modal/parts/ModalTitleParts.vue'
import ModalMessageParts from '@/components/common/modal/parts/ModalMessageParts.vue'
import ModalCouponPlanCardParts from '@/components/common/modal/parts/ModalCouponPlanCardParts.vue'
import AtomButton from '@/components/atoms/AtomButton.vue'
import StoreUtil from '@/store/StoreUtil'
import ContractPlanDocument from '@/store/stores/collectionModule/documents/plan/ContractPlanDocument'

export default defineComponent({
  name: 'OneTimePassRegisterModalSection',
  components: { AtomButton, ModalCouponPlanCardParts, ModalMessageParts, ModalTitleParts },
  setup(_, { emit }) {
    const oneTimePassPageStore = StoreUtil.useStore('OneTimePassPageStore')
    const { oneTimePassPlan } = oneTimePassPageStore

    /**
     * プラン登録ありのワンタイムパス登録時の処理
     */
    const handleRegistrationClicked = () => {
      emit('onClickRegistration')
    }

    return {
      oneTimePassPlan: oneTimePassPlan as Ref<ContractPlanDocument | null>,
      handleRegistrationClicked,
    }
  },
})
</script>

<style scoped lang="scss">
.one-time-pass-register-modal-section {
  &__header {
    .modal {
      &__message {
        white-space: pre-wrap;
      }
    }
  }

  &__body,
  &__footer {
    margin-top: 24px;
  }
}
</style>
